import { Component, HostListener, Renderer2, RendererFactory2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { path_module_complaint, path_module_public } from '@app/models/routes.name';
import { DataService } from '@app/services/data.service';
import { DomainService } from '@app/services/domain.service';
import { EmployerService } from '@app/services/employer.service';
import { PlatformService } from '@app/services/platform.service';
import { ScriptService } from '@app/services/script.service';
import { status_code } from 'functions/src/help/status-query';
import { filter } from 'rxjs';

@Component({
  selector: 'app-layout-complaint-register',
  templateUrl: './layout-complaint-register.component.html',
  styleUrls: ['./layout-complaint-register.component.css']
})
export class LayoutComplaintRegisterComponent {
  public urlEmployer: string = '';

  @HostListener('window:resize')
  onResize(): void {
    this.scriptService.updateAllDynamicColWidths();
    this.scriptService.hideLateralMenubarTogglerControl();
  }

  public currentTs: number = 0;
  public employerName: string = '';
  public employerLogo: string = '';
  private renderer: Renderer2;
  public path_module_complaint = path_module_complaint;
  public showLateralBar: boolean = true;

  constructor(
    private employerService: EmployerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    rendererFactory: RendererFactory2,
    private scriptService: ScriptService,
    private dataService: DataService,
    public domainService: DomainService,
    private platformService: PlatformService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.renderer.addClass(document.body, 'online-institution');
    this.renderer.addClass(document.body, 'internal-area');

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentTs = new Date().getTime();
    });
  }

  ngOnInit() {

    const urlEmployer = this.activatedRoute.snapshot.paramMap.get('urlEmployer') || this.domainService.getFisrtSubdomain();

    let req = {
      urlEmployer
    };

    this.employerService.getEmployerComplaintProfile(req).then(
      (res) => {

        if (res.status_code !== status_code.success) {
          this.showLateralBar = false;


          if (this.platformService.isPlatformBrowser) {
            if (this.domainService.isComplaintChannelDomain()) {
              this.router.navigate([path_module_complaint.not_found]);
            }
            else {
              this.router.navigate([urlEmployer, path_module_complaint.module, path_module_complaint.not_found]);
            }
          }


          return;
        }

        this.dataService.nextSharedData({ module: 'complaint-register', value: res.data })

        this.employerName = res.data?.employerName;
        this.employerLogo = res.data?.employerLogo;
        this.urlEmployer = urlEmployer;

      },
      (err) => {
        this.showLateralBar = false;

        if (this.platformService.isPlatformBrowser) {

          if (this.domainService.isComplaintChannelDomain()) {
            this.router.navigate([path_module_complaint.not_found]);
          }
          else {
            this.router.navigate([urlEmployer, path_module_complaint.module, path_module_complaint.not_found]);
          }
        }

        console.error(err);
      }
    );
  }

  ngAfterViewInit(): void {
    this.scriptService.updateAllDynamicColWidths();
    setTimeout(() => {
      this.scriptService.initPopover();
    }, 100);
  }

  onClickCloseMenu(event: MouseEvent) {
    event.preventDefault();
    this.scriptService.hideLateralMenubarTogglerControl()
  }

  onClickToogleMenu(event: MouseEvent) {
    event.preventDefault();

    this.scriptService.lateralMenubarTogglerControl();
  }

}
